import React, {useEffect, useState, useRef} from 'react'
import { FloatButton } from "antd";
import { ArrowUpward } from "@mui/icons-material";

const FloatingScrollToTop = ({ scrollRef, bottomPosition = '80px' }) => {
    const buttonRef = useRef();
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (scrollRef?.current?.scrollTop > 200) {
                setShowButton(true);
            } else {
                setShowButton(false);
            }
        };

        const currentRef = scrollRef?.current;
        if (currentRef) {
            currentRef.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (currentRef) {
                currentRef.removeEventListener('scroll', handleScroll);
            }
        };
    }, [scrollRef]);

    useEffect(() => {
        if(buttonRef?.current) {
            const describedbyAttributes = buttonRef.current.querySelectorAll('[aria-describedby^=":"]');
            describedbyAttributes?.forEach((el) => {
                el.removeAttribute('aria-describedby');
            });
        }
    }, [buttonRef.current]);

    const handleScrollToTop = () => {
        scrollRef?.current.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    return(
        <FloatButton
            id="scroll-to-top"
            ref={buttonRef}
            icon={<ArrowUpward fontSize={"inherit"} />}
            onClick={() => handleScrollToTop()}
            tooltip={"Scroll to top"}
            aria-label={"Scroll to top"}
            style={{bottom: bottomPosition, width: "50px", height: "50px"}}
            className={`ch-fab-scroll-to-top ${showButton ? ' visible' : ''}`}
        />
    )
}

export default FloatingScrollToTop;